/* November 2026 campaign. Existing theme components stay in place. */
(function () {
  'use strict';
  function selectPhase(phases, now) {
    return phases.find(function (p) { return now >= Date.parse(p.start) && now < Date.parse(p.end); }) || null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { selectPhase: selectPhase };
  if (typeof document === 'undefined') return;
  var configNode = document.getElementById('mcsc-november-config');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent);
  var theme = window.Shopify && window.Shopify.theme;
  var query = new URLSearchParams(window.location.search);
  var requested = query.get('mcsc_campaign_preview');
  var reviewAllowed = theme && String(theme.id) === String(config.reviewThemeId) && ['unpublished', 'development'].includes(theme.role);
  var reviewTime = reviewAllowed && requested && config.reviewTimes[requested];
  if (!config.enabled && !reviewTime) return;
  var originalAttributes = new Map();
  var originalBars = new Map();
  var offset = 0;
  var syncedAt = 0;
  var active = null;
  var clockReady = Boolean(reviewTime);
  var mobile = window.matchMedia('(max-width: 749px)');
  var css = document.createElement('style');
  css.textContent = '[data-mcsc-bar] a{color:inherit;text-decoration:none;display:block}' +
    '[data-mcsc-bar] .mcsc-bar-copy{white-space:nowrap;line-height:1.4}' +
    '@media(max-width:749px){[data-mcsc-bar] .mcsc-bar-copy{font-size:clamp(10px,2.85vw,13px)}}' +
    '[data-mcsc-hero] .slideshow__picture{display:block}' +
    '[data-mcsc-hero] .hero-link img{width:100%;height:auto}' +
    '@media(max-width:749px){[data-mcsc-hero].banner--adapt_image::before,[data-mcsc-hero].banner--adapt_image .media::before{padding-bottom:160%!important}}' +
    '@media(min-width:750px){[data-mcsc-hero].banner--adapt_image::before,[data-mcsc-hero].banner--adapt_image .media::before{padding-bottom:43.333333%!important}}';
  document.head.appendChild(css);
  function setAttribute(el, name, value) {
    if (!el) return;
    if (!originalAttributes.has(el)) originalAttributes.set(el, {});
    var attrs = originalAttributes.get(el);
    if (!(name in attrs)) attrs[name] = el.getAttribute(name);
    if (el.getAttribute(name) === value) return;
    if (value === null) el.removeAttribute(name); else el.setAttribute(name, value);
  }
  function restore() {
    originalAttributes.forEach(function (attrs, el) {
      Object.keys(attrs).forEach(function (name) {
        if (attrs[name] === null) el.removeAttribute(name); else el.setAttribute(name, attrs[name]);
      });
    });
    originalAttributes.clear();
    originalBars.forEach(function (html, el) { el.innerHTML = html; el.removeAttribute('data-mcsc-bar'); });
    originalBars.clear();
    document.querySelectorAll('[data-mcsc-hero]').forEach(function (el) { el.removeAttribute('data-mcsc-hero'); });
    configNode.removeAttribute('data-active-phase');
    active = null;
  }
  function replaceBar(phase) {
    var text = mobile.matches && phase.mobile ? phase.mobile : phase.text;
    var bars = document.querySelectorAll(config.market === 'CA' ? '.announcement-bar' : '.top-bar');
    bars.forEach(function (bar) {
      if (!originalBars.has(bar)) originalBars.set(bar, bar.innerHTML);
      if (bar.dataset.mcscBar === text) return;
      bar.dataset.mcscBar = text;
      var link = document.createElement('a');
      link.href = config.destination;
      link.className = config.market === 'CA' ? 'announcement-bar__link link link--text focus-inset' : 'mcsc-bar-link';
      var copy = document.createElement(config.market === 'CA' ? 'p' : 'span');
      copy.className = 'mcsc-bar-copy' + (config.market === 'CA' ? ' announcement-bar__message h5' : ' top-bar-text');
      copy.textContent = text;
      link.appendChild(copy);
      bar.replaceChildren(link);
    });
  }
  function replaceImage(img, url, width, height, label) {
    if (!img) return;
    setAttribute(img, 'src', url);
    setAttribute(img, 'srcset', null);
    setAttribute(img, 'sizes', null);
    setAttribute(img, 'width', String(width));
    setAttribute(img, 'height', String(height));
    setAttribute(img, 'alt', label);
  }
  function replaceHero(phase) {
    var art = config.art[phase.hero];
    if (config.market === 'CA') {
      var slider = document.querySelector('[id^="Slider-"][id$="__slideshow_bN6kHE"]');
      if (!slider) return;
      var slide = slider.querySelector('.slideshow__slide');
      if (!slide) return;
      slider.setAttribute('data-mcsc-hero', phase.hero);
      var picture = slide.querySelector('picture');
      replaceImage(picture && picture.querySelector('img'), art.desktop, 3000, 1300, art.label);
      if (picture) picture.querySelectorAll('source').forEach(function (source) {
        setAttribute(source, 'srcset', art.mobile);
        setAttribute(source, 'width', '1000');
        setAttribute(source, 'height', '1600');
      });
      var link = slide.querySelector('.slideshow__slide-link');
      setAttribute(link, 'href', config.destination);
      setAttribute(link, 'aria-label', art.label);
    } else {
      var carousel = document.querySelector('.hero-carousel');
      if (!carousel || !carousel.classList.contains('slick-initialized')) return;
      // Slick duplicates slides for infinite scrolling. Update every copy of slide zero.
      var slides = Array.from(carousel.querySelectorAll('[data-slick-index]')).filter(function (slide) {
        var count = carousel.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
        return count && Number(slide.getAttribute('data-slick-index')) % count === 0;
      });
      slides.filter(Boolean).forEach(function (slide) {
        slide.setAttribute('data-mcsc-hero', phase.hero);
        slide.querySelectorAll('a.hero-link').forEach(function (link) {
          var isMobile = link.classList.contains('hide-desktop');
          setAttribute(link, 'href', config.destination);
          setAttribute(link, 'aria-label', art.label);
          replaceImage(link.querySelector('img'), isMobile ? art.mobile : art.desktop, isMobile ? 1000 : 3000, isMobile ? 1600 : 1300, art.label);
        });
      });
    }
  }
  function render() {
    if (!clockReady) return;
    var now = reviewTime ? Date.parse(reviewTime) : Date.now() + offset;
    var phase = selectPhase(config.phases, now);
    if (!phase) { if (active) restore(); return; }
    active = phase.id;
    replaceBar(phase);
    replaceHero(phase);
    configNode.dataset.activePhase = phase.id;
  }
  async function syncClock() {
    if (reviewTime) { render(); return; }
    // A fresh response Date avoids depending on the visitor's timezone or wall clock.
    try {
      var sent = Date.now();
      var response = await fetch('/?mcsc_clock=' + sent, { method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
      var serverTime = Date.parse(response.headers.get('Date'));
      if (!Number.isFinite(serverTime)) throw new Error('Missing server date');
      offset = serverTime + (Date.now() - sent) / 2 - Date.now();
      syncedAt = Date.now();
      clockReady = true;
      render();
    } catch (_) {
      // Keep the original non-sale content when the current time cannot be verified.
      if (!syncedAt || Date.now() - syncedAt > 300000) { clockReady = false; restore(); }
    }
  }
  function start() {
    syncClock();
    window.setInterval(render, 1000);
    window.setInterval(syncClock, 60000);
    mobile.addEventListener('change', render);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) syncClock(); });
    document.addEventListener('shopify:section:load', render);
    // Includes late carousel initialization without observing unrelated page updates.
    window.addEventListener('load', render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}());
